"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _Checkbox = require("./Checkbox.styles");

var _elements = require("../../styles/elements");

var Indeterminate = (0, _base["default"])("span", {
  target: "eoozszg0",
  label: "Indeterminate"
})(_Checkbox.checkbox, ";");
var Checkbox = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var id = _ref.id,
      indeterminate = _ref.indeterminate,
      children = _ref.children,
      className = _ref.className,
      onChange = _ref.onChange,
      checked = _ref.checked,
      value = _ref.value,
      disabled = _ref.disabled,
      defaultChecked = _ref.defaultChecked,
      truncate = _ref.truncate,
      gap = _ref.gap;
  var inputRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    // Set indeterminate attribute through js to make the checkbox show correct indeterminate state
    if (indeterminate !== undefined) {
      inputRef.current.indeterminate = indeterminate;
    } // Fix the issue of can't change checked state through change the attribute in table selection


    if (defaultChecked !== undefined) {
      inputRef.current.defaultChecked = defaultChecked;
    }

    if (checked !== undefined) {
      inputRef.current.checked = checked;
    }
  }, [checked, indeterminate, inputRef, defaultChecked]);
  return (0, _jsxRuntime.jsxs)(Indeterminate, {
    indeterminate: indeterminate,
    className: className,
    truncate: truncate,
    hasChildren: !!children,
    ref: ref,
    gap: gap,
    children: [(0, _jsxRuntime.jsx)("input", {
      type: "checkbox",
      css: _elements.input.styles.preflight,
      className: "grui",
      id: id,
      onChange: onChange,
      value: value,
      disabled: disabled,
      ref: inputRef
    }), (0, _jsxRuntime.jsxs)("label", {
      htmlFor: id,
      children: [(0, _jsxRuntime.jsx)("span", {
        children: (0, _jsxRuntime.jsx)("span", {})
      }), truncate ? (0, _jsxRuntime.jsx)("div", {
        className: "grui truncate",
        children: children
      }) : children]
    })]
  });
});
Checkbox.propTypes = {
  id: _propTypes.string.isRequired,
  indeterminate: _propTypes.bool,
  children: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.string]),
  className: _propTypes.string,
  onChange: _propTypes.func,
  checked: _propTypes.bool,
  value: _propTypes.string,
  disabled: _propTypes.bool,
  defaultChecked: _propTypes.bool,

  /**
   * Whether the label text is truncated
   */
  truncate: _propTypes.bool,

  /**
   * content's spacing to checkbox
   */
  gap: _propTypes.number
};
Checkbox.defaultProps = {
  indeterminate: false,
  children: undefined,
  className: undefined,
  onChange: undefined,
  checked: undefined,
  value: undefined,
  disabled: false,
  defaultChecked: undefined,
  truncate: false,
  gap: 8
};
Checkbox.displayName = 'Checkbox';
var _default = Checkbox;
exports["default"] = _default;
//# sourceMappingURL=Checkbox.js.map